import { Pipe, PipeTransform } from '@angular/core';

import { environment } from '@environment';
import { CurrencyFormatPipe } from '@app/pipes/currency-format.pipe';
import { AirPriceRangeTypes } from '@shared/flight-itinerary/entities/filters';
import { AIR_PRICE_RANGE_LABELS } from '@app/modules/flight-results/constants/filters.constants';
import { TranslatePipe } from '@app/translate/TranslatePipe';

@Pipe({
  name: 'priceRangeCurrencyFormatter',
  standalone: false
})
export class PriceRangeCurrencyFormatterPipe implements PipeTransform {

  constructor(
    private translatePipe: TranslatePipe,
    private currencyFormatter: CurrencyFormatPipe) { }

  transform(data: string): string {

    const arrayRange = data.replace(/\s/g, '').split('-');
    let value: string;

    if (arrayRange.length > 1) {
      const lowerBound = arrayRange[0] === AirPriceRangeTypes.PriceFrom ?
        this.translatePipe.transform(AIR_PRICE_RANGE_LABELS[AirPriceRangeTypes.PriceFrom]) :
        this.currencyFormatter.transform(Number(arrayRange[0]), environment.countryInfo.currency_code);

      const upperBound = arrayRange[1] === AirPriceRangeTypes.PriceTo ?
        this.translatePipe.transform(AIR_PRICE_RANGE_LABELS[AirPriceRangeTypes.PriceTo]) :
        this.currencyFormatter.transform(Number(arrayRange[1]), environment.countryInfo.currency_code);

      value = arrayRange[0] === AirPriceRangeTypes.PriceFrom || arrayRange[1] === AirPriceRangeTypes.PriceTo ?
        `${lowerBound} ${upperBound}` : `${lowerBound} - ${upperBound}`;
    } else {
      value = this.currencyFormatter.transform(Number(data), environment.countryInfo.currency_code);
    }

    return value;
  }
}
